// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/selected-flights',
    name: 'selected-cotizador-flights',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/booking/cotizador/selected/flights/Index.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'cotizador',
    },
  },
  {
    path: '/success-cotitation',
    name: 'success-cotitation',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/messages/SuccessCotization.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'cotizador',
    },
  },
]

export default formTable
